import PT_Sans_Bold from './fonts/PTSans-Bold.ttf'
import PT_Sans_Regular from './fonts/PTSans-Regular.ttf'
import PT_Sans_Bold_Italic from './fonts/PTSans-BoldItalic.ttf'
import PT_Sans_Regular_Italic from './fonts/PTSans-RegularItalic.ttf'
import Regular from './fonts/OpenSans-Regular.ttf'
import SemiBold from './fonts/OpenSans-SemiBold.ttf'
import { css } from 'styled-components'

export default css`

@font-face {
  font-family: Open Sans;
  font-style: normal;
  font-weight: 400;
  src: url(${Regular}) format('truetype');
  font-display: swap;
}
@font-face {
  font-family: Open Sans-SemiBold;
  font-style: normal;
  font-weight: 600;
  src: url(${SemiBold}) format('truetype');
  font-display: swap;
}
@font-face {
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  src: url(${SemiBold}) format('truetype');
  font-display: swap;
}

@font-face {
  font-family: PT Sans;
  font-style: normal;
  font-weight: 400;
  src: url(${PT_Sans_Regular}) format('truetype');
  font-display: swap;
}

@font-face {
  font-family: PT Sans;
  font-style: normal;
  font-weight: 700;
  src: url(${PT_Sans_Bold}) format('truetype');
  font-display: swap;
}

@font-face {
  font-family: PT Sans;
  font-style: italic;
  font-weight: 400;
  src: url(${PT_Sans_Regular_Italic}) format('truetype');
  font-display: swap;
}

@font-face {
  font-family: PT Sans;
  font-style: italic;
  font-weight: 700;
  src: url(${PT_Sans_Bold_Italic}) format('truetype');
  font-display: swap;
}

`
